import { render } from "./FancyboxBlock.vue?vue&type=template&id=12e64f66"
import script from "./FancyboxBlock.vue?vue&type=script&lang=js"
export * from "./FancyboxBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__